/**
 * @param {any} $scope
 * @param {import('~/scripts/services/form.service').default} FormService
 */
export default /* @ngInject */ (
	$scope,
	FormService,
) => {
	$scope.options = $scope.options || {};
	if (!$scope.data) {
		$scope.data = {};
	}
	if (!$scope.data[$scope.component.key]) {
		$scope.data[$scope.component.key] = [
			{data: {}}
		];
	}

	const loadForm = async () => {
		if (!Array.isArray($scope.component.kdata?.path)) {
			return;
		}
		const options = {
			create: $scope.component.kdata.create,
			rg: $scope.component.kdata.rg,
		};
		const { kid } = ($scope.component.kdata.node_kid && !options.create) || $scope.component.kdata.path.at(-1);
		const form = await FormService.load(kid, options);
		if (form) {
			$scope.componentForm = form;
		}		// if (create && this.#newKid && !parent) {
		// 	formClass.kid = this.#newKid;
		// }
		// await this.loadForm(result, parent, formClass, create, false, options);
		// if (create && !parent && this.#newKid) {
		// 	formClass.kid = this.#newKid;
		// }
	};

	$scope.$watch('component.form', () => loadForm());

	// $scope.$watch('data[component.key]', submission => {
	// 	if (!submission) {
	// 		return;
	// 	}
	// 	angular.merge($scope.data[$scope.component.key], submission);
	// }, true);
}
